import './CountryFlag.scss';

const modules = import.meta.glob('../../assets/optimised-flags/*.webp', {
  eager: true,
  import: 'default',
});

const flags = Object.fromEntries(
  Object.entries(modules).map(([path, src]) => [
    path.substring(
      '../../assets/optimised-flags/'.length,
      path.search('.webp'),
    ),
    src as string,
  ]),
);

interface Props {
  countryCode: string;
  width?: number;
  height?: number;
}

const className = 'c-CountryFlag';

const CountryFlag = ({ countryCode, width = 32, height = 24 }: Props) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src={countryCode in flags ? flags[countryCode] : flags.xx}
      alt=""
    />
  );
};

export default CountryFlag;
